import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';

@Component({
  selector: 'app-skin-temperature',
  templateUrl: './skin-temperature.component.html',
  styleUrls: ['./skin-temperature.component.css']
})
export class SkinTemperatureComponent implements OnInit, OnChanges, OnDestroy {
  @Input() entityId: any;
  @Input() periodFilter: any;
  @Input() widgetData: any;
  @Input() config: any;
  isError: boolean = false;
  isloader: boolean = false;
  today: any = new Date();
  skinTemperature: any;
  lowerAlertThreshold: any;
  upperAlertThreshold: any;
  attributeValueMarker: any;
  sourceTimestamp: any;
  sensorId: any;

  private _subscription: Subscription;
  private _startTime: Date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999);
  private _intervalTimer: any;
  private _attributeDataSubscription: Subscription;

  
  constructor( private _service: EntitiesServiceService, private _sharedService: ServicecallService, private _datePipe: DatePipe, private _dataSer: DataService) {
    this._subscription = _dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh') {
        this._getSkinTemperature();
      }
    });
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    this._getSkinTemperature();
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._attributeDataSubscription?.unsubscribe();
    this._clearTimer();
  }

  private _refreshApi() {
    if (+this.widgetData?.refreshRate) {
      this._clearTimer();
      this._intervalTimer = setInterval(() => {
        this._getSkinTemperature();
      }, +this.widgetData?.refreshRate);
      this.isError = false;
    }
  }

  private _clearTimer() {
    if (this._intervalTimer) {
      clearInterval(this._intervalTimer);
    }
  }

  private _getSkinTemperature() {
    const reqData = {
      from: this._datePipe.transform(this._startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityId: this.entityId,
      siteId: this._sharedService.getSiteId()
    }
    const dummy = [
      {
        "attributeName": "Battery",
        "attributeValue": "155.0",
        "condition": "Charged"
      },
      {
        "attributeName": "Skin Temperature °C",
        "attributeValue": "21"
      },
      {
        "attributeName": "Respiratory Rate",
        "attributeValue": "8"
      },
      {
        "attributeName": "Activity",
        "attributeValue": "-76.0",
        "condition": "Inactive"
      },
      {
        "attributeName": "Flag",
        "attributeValue": "6.0"
      }
    ]
    this._attributeDataSubscription = this._service.attributeData(reqData).subscribe(
      {
        next: (result: any) => {
          if (result?.status && result?.response?.data?.length) {
            this.skinTemperature = result?.response?.data?.find((item: any) => item.attributeName === "Skin Temperature °C");
            this.sensorId = result?.response?.data?.find((item: any) => item.attributeName === "Battery")?.deviceName;
            if (this.skinTemperature && Object.keys(this.skinTemperature)?.length) {
              this.sourceTimestamp = this.skinTemperature?.sourceTimestamp ? this._sharedService.getLastSeenFormat(this.skinTemperature?.sourceTimestamp) : null;
              const skinTemp = Math.abs(+result?.response?.data?.find((item: any) => item.attributeName === "Skin Temperature °C")?.attributeValue);
              if (this.config.length) {
                const threshold = this.config.find((item: any) => item?.name?.toLowerCase() === this.skinTemperature?.attributeName?.toLowerCase());
                if (threshold && Object.keys(threshold)?.length) {
                  this.lowerAlertThreshold = +threshold.alertThreshold?.find((lower: any) => lower.name == 'lower')?.threshold;
                  this.upperAlertThreshold = +threshold.alertThreshold?.find((upper: any) => upper.name == 'upper')?.threshold;
                  if (skinTemp <= this.lowerAlertThreshold) {
                    this.attributeValueMarker = (skinTemp * 30) / this.lowerAlertThreshold;
                  } else if (skinTemp > this.lowerAlertThreshold && skinTemp <= this.upperAlertThreshold) {
                    // if (skinTemp > 30) {
                    //   this.attributeValueMarker = (((skinTemp - 30) / (this.upperAlertThreshold - 30)) * 40) + 30;
                    // } else {
                    //   this.attributeValueMarker = (((skinTemp - this.lowerAlertThreshold) / 40) * 100) + 30;
                    // }
                    this.attributeValueMarker = ((38 * skinTemp) / this.upperAlertThreshold) + 30;
                  } else {
                    this.attributeValueMarker = 90;
                  }
                }
              }
            } else {
              this.skinTemperature = {};
            }
          } else {
            this.skinTemperature = {};
          }
          this.isloader = false;
          this._refreshApi();
        },
        error: (error) => {
          if (error) {
            this.isloader = false;
            this.isError = true;
            this._refreshApi();
          }
        }
      }
    )
  }

}
